import MinimapPlugin from './lib/index'

export default MinimapPlugin
